<template>
    <v-skeleton-loader
        :aria-busy="false"
        type="card-avatar, article, actions"
    ></v-skeleton-loader>
</template>

<script>
export default {}
</script>
